module.exports = __webpack_public_path__ + "static/media/logo.775c5161.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 291
// module chunks = 0